module.exports = __webpack_public_path__ + "img/thumbs-up.7c39be07.svg";